import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class VersionService {

constructor(private http: HttpClient) { }

getBackendVersion() {
  console.log('Url from version service:', environment.apiServerUrl);
    return this.http.get<{
      version: string;
      build: string;
      deploymentName: string;
    }>(`${environment.apiServerUrl}/version`); 
  }
}
